module.exports = __webpack_public_path__ + "115e6f565bc996f341085256ec5bc02c.png";